import Request from '@/services/request';
import {
  WMS_AGREEMENT_ACCEPT,
  WMS_AGREEMENT_STATUS,
} from '@/utils/enum/endpoints';

const Req = new Request();
const BASE_URL = '/sellerofficeapi/rest';

export async function checkWmsAgreementStatus() {
  const { data } = await Req.get(WMS_AGREEMENT_STATUS, null, {
    baseURL: BASE_URL,
    headers: { Accept: 'application/json' },
  });

  return {
    approved: !!data?.approved,
    contractContent: data?.contractContent ?? null,
  };
}

export async function acceptWmsAgreement() {
  return Req.post(WMS_AGREEMENT_ACCEPT, {}, { baseURL: BASE_URL });
}
